import { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { Form, message } from 'antd';
// @ts-ignore
import Base64 from 'crypto-js/enc-base64';
// @ts-ignore
import Utf8 from 'crypto-js/enc-utf8';
import EcoLink from 'eco-design/base/eco-link';
import debounce from 'lodash/debounce';
import ReCAPTCHA from 'react-google-recaptcha';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import EcoDialog from 'eco-design/base/eco-dialog';
import styled from './login.module.scss';
import Button from '@/components/UI/Button';
import { useGlobal } from '@/utils/useGlobal';
import SocialLoginLinks from '@/components/SocailLoginLinks';
import Input from '@/components/UI/Input';
import CountDown from '@/components/CountDown';
import Checkbox from '@/components/UI/Checkbox';
import { getKaamelPlan } from '@/utils/kaamelTest';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { onLogin } from '@/utils/cookie';
import { LOGIN_MAP, FORUM_APPID_MAP } from '@/constants/forum';
import { getCountryRegion } from '@/utils/countryRegion';
import { ENGLISH_LANG, i18nMap, newVersionRegion, rpcMap } from '@/constants';
import { isMembersFestival } from '@/utils/membersFestival';
import { getHostApi, redirectTo404 } from '@/utils';
import { authSignIn, checkHumanMachine, toLogin } from '@/service';
import { EFAkIn, EFAkout } from '@/components/UI/svg/My';

type InputFieldType = 'email' | 'code';

interface PasswordlessType {
    visible: boolean;
    onCancel: () => void;
}

interface VerifyCodeResponse {
    code: string;
    message?: string;
}

const HOMEBATTERY_REDIRECT = process.env.NEXT_PUBLIC_HOME_BATTERY_DOMAIN;
const RESEND_CODE_COUNTDOWN = 60;
const WORDPRESS_SITE = process.env.NEXT_PUBLIC_WORDPRESS_SITE;
const WEB_HOST = process.env.NEXT_PUBLIC_WEB_HOST;
const FORUM_HOST = process.env.NEXT_PUBLIC_FORUM_DOMAIN;
const prevUrlBalckList = ['/login', '/register', '/validate', '/forget'];

message.config({
    duration: 10,
    top: 150,
    getContainer: () => document.body,
    maxCount: 3,
});

const Login = ({ visible, onCancel }: PasswordlessType) => {
    const { useLang, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang('shared.global_login');
    const { locale, query } = useRouter();
    const errTipRef = useRef(null);
    const isNewVersionRegion = newVersionRegion(locale);
    const recaptchaRef = useRef();

    const router = useRouter();
    const [loading, setLoading] = useState(false);
    const [errorTip, setErrorTip] = useState('');
    const [isErrorTip, setIsErrorTip] = useState(false);
    const [focus, setFocus] = useState('');
    const [allValidate, setAllValidate] = useState({ email: false, password: false });
    const [humanCheck, setHumanCheck] = useState(false);
    const [isShowForget, setIsShowForget] = useState(true);
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [email, setEmail] = useState('');
    const [pwd, setPwd] = useState('');
    const [kaamelInfo, setKaamelInfo] = useState<any>(null);
    const hl = rpcMap[ENGLISH_LANG.includes(locale) ? 'en' : locale];

    const { _source } = query;
    const redirect = typeof window !== 'undefined' ? window.location.href : router.asPath;

    // let HOME_HOST = `${WEB_HOST}/${router.locale}`;
    // // 社区
    // if (_source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY) {
    //     HOME_HOST = `${FORUM_HOST}/${router.locale}`;
    // }
    // 家储
    // if (redirectUrl.indexOf('https://homebattery') > -1 || redirectUrl.indexOf('https://enterprise') > -1) {
    //     HOME_HOST = `${HOMEBATTERY_REDIRECT}${router.locale}`;
    // }

    const [form] = Form.useForm();
    const LOGIN_HOST = getHostApi(router.locale).NEXT_PUBLIC_LOGIN_HOST;
    let open_site: string | undefined = '';
    switch (getCountryRegion(locale)) {
        case 'cn':
            open_site = process.env.NEXT_PUBLIC_OPEN_SITE_CN;
            break;
        case 'eu':
            open_site = process.env.NEXT_PUBLIC_OPEN_SITE_EU;
            break;
        default:
            open_site = process.env.NEXT_PUBLIC_OPEN_SITE;
            break;
    }

    const validPrePath = (path: string) => {
        if (typeof window !== 'undefined') {
            const origin = (window as any).location.origin;
            return (path.includes(origin) && path) || '';
        }
        return '';
    };

    const getShopfiyReturnToNew = (url: string) => {
        // redirect > prevPath > home
        const homePath = `/${router?.locale || ''}`;
        if (typeof window === 'undefined') return homePath;

        let { redirect } = router.query;

        const origin = window.location.origin;
        if (redirect && !prevUrlBalckList.some((item: any) => redirect.includes(item))) {
            if (!redirect.startsWith('http') && !redirect.startsWith('www.')) {
                redirect = `${origin}${redirect.startsWith('/') ? redirect : `/${redirect}`}`;
                return decodeURIComponent(`${redirect}`);
            }
            if ((redirect.startsWith('http') || redirect.startsWith('www.')) && !redirect.includes('.ecoflow.com')) {
                redirect = `${origin}${homePath}`;
                return decodeURIComponent(`${redirect}`);
            }
            return decodeURIComponent(`${redirect}`);
        }

        const prevPath = typeof window !== 'undefined' ? document.referrer : '';

        let prevRoute = validPrePath(prevPath);
        if (prevRoute && !prevUrlBalckList.some((item: any) => prevRoute.includes(item))) {
            if (!prevRoute.startsWith('http') && !prevRoute.startsWith('www.')) {
                prevRoute = `${origin}${prevRoute.startsWith('/') ? prevRoute : `/${prevRoute}`}`;
            }
            if ((prevRoute.startsWith('http') || prevRoute.startsWith('www.')) && !prevRoute.includes('.ecolfow.com')) {
                prevRoute = `${origin}${homePath}`;
            }
            return decodeURIComponent(`${prevRoute}`);
        }
        return url || decodeURIComponent(`${origin}${homePath}`);
    };

    const syncLoginShopify = async (url: string): Promise<string> => {
        return new Promise(async (resolve, reject) => {
            let returnToNew = getShopfiyReturnToNew(url);

            // 外层对 url 判断移到这里（原有逻辑）
            if (returnToNew) {
                returnToNew = returnToNew.startsWith('http') || returnToNew.startsWith('www.') ? returnToNew : `${WEB_HOST}${returnToNew}`;
            } else {
                returnToNew = `${WEB_HOST}/${locale}`;
            }

            const params = {
                returnToNew,
                url: `https://${router?.locale}.ecoflow.com`,
            };
            const res = await authSignIn(params, router?.locale);
            if (res?.code !== '0') {
                reject(res?.message);
            } else {
                resolve(res?.data || `/${router.locale}`);
            }
        });
    };

    const handleBeforeFinish = async () => {
        if (humanCheck && recaptchaResponse) {
            onFinish({});
            return;
        }
        const params = {
            functionName: 'login',
            account: email,
        };
        setLoading(true);

        try {
            const res = await checkHumanMachine(params);
            setLoading(false);

            if (res.code === '0') {
                setHumanCheck(res.data);
                if (!res.data) {
                    onFinish({});
                }
            } else {
                setErrorTip(res.message);
                setIsErrorTip(true);
            }

            return;
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    // Login
    const onFinish = async (values: any) => {
        const recaptchaRes = humanCheck ? { recaptchaResponse } : {};

        const params = {
            source: LOGIN_MAP[_source] || 'ECOFLOW_WEB',
            userType: 'ECOFLOW', //用户类型
            scene: LOGIN_MAP[_source] || 'ECOFLOW_WEB', //登陆场景
            logInSource: 1, // 处理注销用户登录
            email: values.email || email,
            password: Base64.stringify(Utf8.parse(values.password || pwd)),
            ...recaptchaRes,
        };

        gtm.push({
            event: 'uaEvent',
            event_name: 'click_login',
            button_name: t('site_login_login'),
        });

        setLoading(true);

        try {
            const res: any = await toLogin(params, '', _source === LOGIN_MAP.ECOFLOW_WEB_COMMUNITY ? FORUM_APPID_MAP[locale] : '');
            if (res.code === '0') {
                // const redirectUrl = '';
                const { redirect = '', scene } = router.query;
                // 是否是家储
                const IS_HOME_BATTERY = redirect.indexOf('https://homebattery') > -1 || redirect.indexOf('https://enterprise') > -1;
                // 用户信息存储到cookie中
                onLogin(res.data, IS_HOME_BATTERY);

                // 注销中的用户跳转到个人用户页取消注销
                if (res.data?.user?.destroyed === 'DESTROY') {
                    window.location.href = `/${router.locale || ''}/my-account-manage`;
                    return;
                }

                const decodeRedirect = decodeURIComponent(redirect);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'login',
                    page_name: '/login',
                });

                // wordpress 系统第三方
                if (redirect && scene) {
                    if (redirect.includes(HOMEBATTERY_REDIRECT)) {
                        // window.location.href = `${decodeRedirect}?user=${encodeURIComponent(res.data)}`;
                        window.location.href = decodeRedirect;
                        return;
                    }

                    // 测试环境地址http://10.10.12.33/redirect.html
                    window.location.href = `${WORDPRESS_SITE}?returnTo=${decodeRedirect}&token=${res.data.token}`;
                    return;
                }

                //open开发平台
                if (window.opener) {
                    window.opener.postMessage(
                        {
                            userInfo: res.data?.user,
                            token: res.data.token,
                        },
                        open_site,
                    );
                }

                /**
                 * @todo 原积分系统已弃用，现在已经迁移到新官网内部
                 */
                // http://10.10.10.168:3007/points?type=website&website=JAPAN&token=xxx
                // 处理个人积分跳转后，登录过期，跳转回来登录，登录成功后再返回到具体url，暂时用http://10.10.10.168:3007站点
                try {
                    const res2 = await syncLoginShopify(redirect);
                    window.location.href = String(res2);
                } catch (err) {
                    window.location.href = `/${router.locale || ''}`;
                } finally {
                    setLoading(false);
                }
            } else {
                handleLoginError(res);
            }
        } catch (e) {
            handleLoginError({ message: 'error happened' });
        }
    };

    const handleLoginError = (res: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'login_fail',
            page_name: '/login',
        });
        setLoading(false);
        setErrorTip(res.message);
        setIsErrorTip(true);
    };

    // 人机校验 start
    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (!captchaCode) return;
        setRecaptchaResponse(captchaCode);
        // form.validateFields(['recaptchaResponse']);
        form.setFields([
            {
                name: 'recaptchaResponse',
                value: captchaCode,
                errors: [],
            },
        ]);
    };

    // 处理多行错误提示
    useEffect(() => {
        const element: any = errTipRef.current;

        if (!element) return;

        const checkMultiline = () => {
            if (element) {
                const singleLineHeight = parseInt(getComputedStyle(element).lineHeight, 10);
                const totalHeight = element.clientHeight;
                setIsShowForget(!(totalHeight > singleLineHeight));
            }
        };

        const resizeObserver = new ResizeObserver(checkMultiline);
        resizeObserver.observe(element);

        return () => {
            if (element) resizeObserver.unobserve(element);
        };
    }, [errTipRef]);

    useEffect(() => {
        const info = getKaamelPlan();
        setKaamelInfo(info);
    }, []);

    return (
        <EcoDialog className={styled.login} size="large" open={visible} onCancel={onCancel} title={t('site_login_your_ecoflow')}>
            <div>
                <div className={'login-box'}>
                    <div className="right">
                        <div className="content-wrapper">
                            <Form
                                name="normal_login"
                                className="login-form"
                                form={form}
                                autoComplete="off"
                                initialValues={{ remember: true }}
                                onValuesChange={(cValues) => form.validateFields(Object.keys(cValues))}
                            >
                                <div className="inputItem">
                                    <label className={(form.getFieldsValue()['email'] || focus === 'email') && 'active'}>{t('site_login_email')}</label>
                                    <Form.Item
                                        name="email"
                                        shouldUpdate
                                        rules={[
                                            () => ({
                                                validator(_, value) {
                                                    const regx =
                                                        /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                                                    if (!value) {
                                                        setAllValidate({
                                                            ...allValidate,
                                                            ...{ email: false },
                                                        });
                                                        return Promise.reject(new Error(t('site_login_tip_email_empty')));
                                                    }

                                                    if (value && !regx.test(value)) {
                                                        setAllValidate({
                                                            ...allValidate,
                                                            ...{ email: false },
                                                        });
                                                        return Promise.reject(new Error(t('site_login_tip_email_format_incorrect')));
                                                    }

                                                    setEmail(value);
                                                    setAllValidate({
                                                        ...allValidate,
                                                        ...{ email: true },
                                                    });
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                        validateTrigger="onBlur"
                                    >
                                        <Input
                                            className="default-input"
                                            onFocus={() => setFocus('email')}
                                            onBlur={() => {
                                                // 邮箱去空格
                                                const { email, password } = form.getFieldsValue();
                                                form.setFieldsValue({ password, email: email?.trim() });
                                                form.validateFields(['email']);
                                                setFocus('');
                                            }}
                                            autoComplete="off"
                                        />
                                    </Form.Item>
                                </div>
                                <input type="password" style={{ display: 'none' }} />
                                <div className="inputItem password-item">
                                    <label className={(form.getFieldsValue()['password'] || focus === 'password') && 'active'}>
                                        {t('site_login_password')}
                                    </label>
                                    <Form.Item
                                        name="password"
                                        shouldUpdate
                                        rules={[
                                            () => ({
                                                validator(_, value) {
                                                    setIsErrorTip(false);
                                                    if (!value) {
                                                        setAllValidate({
                                                            ...allValidate,
                                                            ...{ password: false },
                                                        });
                                                        return Promise.reject(new Error(t('site_login_tip_password_empty')));
                                                    }
                                                    setPwd(value);
                                                    setAllValidate({
                                                        ...allValidate,
                                                        ...{ password: true },
                                                    });
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                        validateTrigger="onChange"
                                    >
                                        <Input.Password
                                            type="password"
                                            className="default-input"
                                            autoComplete="new-password"
                                            onFocus={() => setFocus('password')}
                                            onBlur={() => setFocus('')}
                                            iconRender={(visible: boolean) => <div>{visible ? <EFAkIn className={'iconfont'} /> : <EFAkout />}</div>}
                                        />
                                    </Form.Item>
                                    {isErrorTip && (
                                        <div ref={errTipRef} className="error-tip">
                                            {errorTip}
                                        </div>
                                    )}
                                </div>
                                <div className={`${isErrorTip ? 'inline-item validate-error' : 'inline-item'} ${!isShowForget ? 'hide-text' : ''}`}>
                                    <Link
                                        href="/forget"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'forgot_password',
                                            button_name: t('site_login_forgot_password'),
                                        }}
                                        selfWin
                                        ariaLabel={t('site_login_forgot_password')}
                                    >
                                        <span className="login-form-inline-forgot">{t('site_login_forgot_password')}</span>
                                    </Link>
                                </div>

                                {isNewVersionRegion && humanCheck && (
                                    <Form.Item
                                        name="recaptchaResponse"
                                        rules={[
                                            {
                                                validator() {
                                                    if (recaptchaResponse) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(t('logintips.site_login_tip_perform_verification'));
                                                },
                                            },
                                        ]}
                                        style={{ marginTop: '12px', marginBottom: '32px' }}
                                    >
                                        <div className="g-recaptcha">
                                            {/* @ts-ignore */}
                                            <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                        </div>
                                    </Form.Item>
                                )}
                                <Form.Item className="form-item1">
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="black-btn large login-form-button login-btn"
                                        loading={loading}
                                        disabled={!(allValidate.email && allValidate.password)}
                                        onClick={async () => {
                                            // 先判断是否进行人机校验
                                            if (isNewVersionRegion) {
                                                handleBeforeFinish();
                                            } else {
                                                await onFinish({});
                                            }
                                        }}
                                    >
                                        {t('site_login_login')}
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </div>
                <div className="divider-line">{`- ${t('site_login_or')} -`}</div>
                <SocialLoginLinks redirectUrl={redirect} showLineLogin={locale === 'jp'} />
            </div>
        </EcoDialog>
    );
};

export default Login;
